import { getView } from './EIDAS/view.constant.js';
import { showFormAlert } from '../view/showFormAlert.js';

/* EXAMPLE stepData
  {
    "certDataSubject": "TEST1 TEST1 TEST1 - 00TEST100E",
    "certDataIssuer": "CAEDICOM04",
    "certDataValidUntil": "2026-02-27T13:41:12Z",
    "address": "",
    "certDataSerialNumber": "30C0297D63873D159E2014B79F51AAEE2C",
    "city": "",
    "postalCode": "",
    "nif": "ES00TEST100E",
    "state": "",
    "certDataValidFrom": "2024-02-28T13:41:13Z",
    "certDataSignature": "6BAD8C1C534F286CC7A5BA63D0287BE3FA99B7AB"
  }
*/
export default {
  events: {
    visible: (eWizard, stepData, _params, _enrollform) => {
      const eForm = eWizard.querySelector('#formEidas');
      eForm.render({
        view: getView(),
        value: {
          form: stepData,
        },
      });
    },
    step: (eWizard, _stepData, resolve, reject) => {
      const eForm = eWizard.querySelector('#formEidas');
      eForm.validate().then(() => {
        if (eForm.ariaInvalid) {
          showFormAlert();
          reject();
        } else {
          // El stepData se actualiza con el propio form
          resolve(eForm.value.form);
        }
      });
    },
  },
  template: `
  <template label="${edicom.locale.translate('global.titleEidas')}">
    <ewc-layout label="${edicom.locale.translate('enrollment.eidas.title')}">
      <div slot="main">
        <ewc-form id="formEidas"></ewc-form>        
      </div>
    </ewc-layout>
  </template>`,
};
